<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { assertValue } from '@libs/utils';

import type { AppImgType } from '../appImg/AppImg.model';
import AppImg from '../appImg/AppImg.vue';

export interface AppImagesLoaderProps {
  urls: string[];
  imgType: AppImgType;
  alt?: string;
}

interface AppImagesLoaderEmit {
  (eventName: 'images-loader-error', src: string): void;
}
const props = defineProps<AppImagesLoaderProps>();
const emit = defineEmits<AppImagesLoaderEmit>();

const src = ref('');
const currentUrlIndex = ref(0);
const imageLoadFailed = ref(false);

onMounted(() => {
  if (props.urls.length > 0) {
    loadNextUrl();
  } else {
    handleError('no url');
  }
});

function loadImageError(failedUrl: string): void {
  if (props.urls[currentUrlIndex.value]) {
    loadNextUrl();
  } else {
    handleError(failedUrl);
  }
}

function loadNextUrl(): void {
  const url = props.urls[currentUrlIndex.value];
  assertValue(url, 'ui > AppImagesLoader.vue > loadNextUrl > url');

  src.value = url;
  currentUrlIndex.value += 1;
}

function handleError(url: string): void {
  imageLoadFailed.value = true;
  emit('images-loader-error', url);
}
</script>

<template>
  <slot v-if="imageLoadFailed" />
  <AppImg
    v-else
    :key="src"
    :src="src"
    :alt="props.alt"
    :img-type="props.imgType"
    @img-load-error="loadImageError"
  />
</template>
